<template>
    <v-card
      :max-height="400"
      :height="360"
      tile
    >
        <v-container>
            <v-row>
                <v-col :cols="12" align="right" class="badge pa- ma-0">
                    <v-icon color="secondary" top x-large v-if="best" left>mdi-checkbox-marked-circle-outline</v-icon>
                </v-col>
                <v-col align="center" justify="center" :cols="12">
                    <v-img
                        v-if="image != ''"
                        :alt="brand + ' ' + model + ' image'"
                        :src="image"
                        :max-width="125"
                    >
                    </v-img>
                    <v-img 
                        v-if="image == ''"
                        src="../../assets/disc.jpeg"
                        :max-width="125"
                        :alt="model"
                    ></v-img>
                </v-col>
            </v-row>
            <v-row>
                <v-col :cols="12" class="text-center">
                    <p class="display-1 r-to-l text-uppercase text-no-wrap ma-0 pa-0">{{model}}</p>
                    <p class="subtitle-2 r-to-l text-no-wrap text-uppercase ma-0 pa-0">{{subtitle}}</p>
                    <p class="pa-0 ma-0 body-1"> {{speed}} | {{glide}} | {{turn}} | {{fade}} </p>
                    <p class="pa-0 ma-0">Skill Level: {{skill}}</p>
                </v-col>
            </v-row>
            <v-row>
                <v-col :cols="6" class="text-left">
                    <v-btn
                        v-if="!isBag"
                        :disabled="DisableAdd"
                        min-width="150"
                        color="secondary"
                        @click="AddBag"
                    >
                        Add to Bag
                    </v-btn>
                    <v-btn v-if="isBag" min-width="150" color="secondary" @click="RemoveBag">Remove</v-btn>
                </v-col>
                <v-col :cols="6" class="text-right"><v-btn min-width="150" color="shop" dark :href="shop" target="_blank" >Buy</v-btn></v-col>

            </v-row>
        </v-container>
    </v-card>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
export default {
    name: "DiscCardViewSmall",
    components: {},
    props: {
        model: {
            type: String,
            default: "Force",
            required: true
        },
        brand: {
            type: String,
            default: "Discraft",
            required: true,
        },
        subtitle: {
            type: String,
            required: true,
        },
        speed: {
            type: Number,
            required: true,
        },
        glide: {
            type: Number,
            required: true,
        },
        turn: {
            type: Number,
            required: true,
        },
        fade: {
            type: Number,
            required: true,
        },
        skill: {
            type: String,
            required: true
        },
        best:{
            type: Boolean,
            default: false,
            required: false
        },
        type: {
            type: String,
        },
        stability:{
            type: String
        },
        id: {
            type: Number,
            required: true
        },
        isBag: {
            type: Boolean,
            required: false,
        },
        image: {
            type: String,
            default: "",
            required: true
        },
        shop: {
            type: String,
            default: "",
            required: true
        },
    },
    data: () => ({
    }),
    methods: {
        ...mapActions(["AddToBag", "RemoveFromBag"]),
        AddBag()
        {
            let obj = {
                id: this.id,
                model: this.model,
                brand: this.brand,
                stability: this.stability,
                type: this.type,
                speed: this.speed,
                glide: this.glide,
                turn: this.turn,
                fade: this.fade,
                skill: this.skill,
                shop: this.shop,
                image: this.image
            };
            this.AddToBag(obj);
        },
        RemoveBag()
        {
            let obj = {
                id: this.id,
            };
            this.RemoveFromBag(obj);
        }
    },
    computed: {
        ...mapGetters(["GetBag"]),
        DisableAdd: function()
        {
            let m = this.GetBag.findIndex(el => el.id == this.id);
            if(m != -1)
            {
                return true;
            }
            return false;
        },
    },
}
</script>

<style scoped>
.r-to-l{
    direction: rtl;
}

.badge {
    position: absolute;
    z-index: 9997;
}

</style>